/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import _ from 'lodash';
import service from '../../services/feedback';

const FEEDBACK_ALL = 'FEEDBACK_ALL';
const FEEDBACK_ONE = 'FEEDBACK_ONE';
const FEEDBACK_DEL = 'FEEDBACK_DEL';
const FEEDBACK_RESET = 'FEEDBACK_RESET';

const state = {
  list: {},
};

const mutations = {
  [FEEDBACK_ALL] (state, groups) {
    state.list = {};
    groups.forEach((feedbackData) => {
      if (!feedbackData) return;

      feedbackData.forEach((feedback) => {
        if (typeof state.list[feedback.recordingId] === 'undefined') {
          state.list[feedback.recordingId] = [];
        }
        state.list[feedback.recordingId].push(feedback);
      });
    });
  },

  [FEEDBACK_ONE] (state, feedbackData) {
    if (!(feedbackData.recordingId in state.list)) {
      state.list[feedbackData.recordingId] = [];
    }
    const list = state.list[feedbackData.recordingId];
    const feedback = _.find(list, s => s.feedbackId === feedbackData.feedbackId);
    if (feedback) {
      _.assign(feedback, feedbackData);
    } else {
      state.list[feedbackData.recordingId].push(feedbackData);
    }
  },

  [FEEDBACK_DEL] (state, feedback) {
    // not using _.pull so Vue detects the change
    const innerList = state.list[feedback.recordingId];
    const index = _.findIndex(innerList, s => s.feedbackId === feedback.feedbackId);
    if (index >= 0) {
      innerList.splice(index, 1);
    }
  },

  [FEEDBACK_RESET] (state) {
    state.list = {};
  }
};

const actions = {
  listGroupFeedback: ({ commit, getters }) => {
    const groups = getters.groups;
    let lookups = [];

    groups.forEach((group) => {
      lookups.push(service.listGroup(group.groupId));
    });
    return window.Promise.all(lookups).then((feedback) => {
      commit(FEEDBACK_ALL, feedback);
    });
  },
  addFeedback: ({ commit, getters }, feedbackData) => {
    return service.post(feedbackData)
      .then((feedbackResponse) => {
        const group = _.find(getters.groups, (g) => feedbackData.groupId === g.groupId);
        const isManager = (group && group.roles.indexOf('manager') !== -1) ? true : false;

        feedbackData.isManager = isManager;
        feedbackData.userId = getters.user.userId;
        feedbackData.feedbackId = feedbackResponse.feedbackId;
        feedbackData.createdDate = new Date();
        commit(FEEDBACK_ONE, feedbackData);
      });
  },
  addScorecardResponse: ({ commit, getters }, feedbackData) => {
    return service.post(feedbackData)
      .then((feedbackResponse) => {
        const group = _.find(getters.groups, (g) => feedbackData.groupId === g.groupId);
        const isManager = (group && group.roles.indexOf('manager') !== -1) ? true : false;

        feedbackData.isManager = isManager;
        feedbackData.userId = getters.user.userId;
        feedbackData.feedbackId = feedbackResponse.feedbackId;
        feedbackData.createdDate = new Date();
        commit(FEEDBACK_ONE, feedbackData);
      });
  },
  deleteFeedback: ({ commit }, feedback) => {
    return service.del(feedback.feedbackId)
      .then(() => {
        commit(FEEDBACK_DEL, feedback);
      });
  },
  updateFeedback: ({ commit }, feedbackData) => {
    return service.put(feedbackData.feedbackId, feedbackData)
      .then(() => {
        commit(FEEDBACK_ONE, feedbackData);
      });
  },
  resetFeedback: ({ commit }) => {
    commit(FEEDBACK_RESET);
  }
};

const getters = {
  feedback: state => state.list
};

export default {
  state,
  mutations,
  actions,
  getters
};
